// extracted by mini-css-extract-plugin
export default {"container":"PrintPricelist_container__2+bq+"};